<template>
  <footer class="footer bg-light no-bd">
    <div class="card">
      <div class="card-body">
        <div class="container clearfix">
          <nav class="float-left">
            <ul class="nav">
              <li class="nav-item">
                <a class="nav-link" href="https://indiefy.net/our-artists" target="_blank">{{ $t('artists') }}</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://indiefy.net/services" target="_blank">{{ $t('services') }}</a>
              </li>
              <li class="nav-item d-none d-sm-block">
                <a class="nav-link" href="https://indiefy.net/blog" target="_blank">Blog</a>
              </li>
              <li class="nav-item d-none d-sm-block">
                <a href="https://facebook.com/indiefyapp" rel="noopener noreferrer" target="_blank" class="nav-link">
                  <i class="fab fa-facebook"></i>
                </a>
              </li>
              <li class="nav-item d-none d-sm-block">
                <a href="https://instagram.com/indiefyapp" rel="noopener noreferrer" target="_blank" class="nav-link">
                  <i class="fab fa-instagram"></i>
                </a>
              </li>
              <li class="nav-item d-none d-sm-block">
                <a href="https://www.youtube.com/channel/UCIb1zDHx1LGw0HB59zbmWIA" rel="noopener noreferrer" target="_blank" class="nav-link">
                  <i class="fab fa-youtube"></i>
                </a>
              </li>
              <li class="nav-item d-none d-sm-block">
                <a class="nav-link" href="mailto:support@indiefy.net" target="_blank">{{ $t('help') }}</a>
              </li>
              <li class="nav-item d-none d-sm-block">
                <a class="nav-link" target="_blank" href="https://help.indiefy.net/knowledge">
                  <i class="far fa-question-circle"></i>
                </a>
              </li>
            </ul>
          </nav>
          <div class="copyright ml-auto">
            &copy; {{ new Date().getFullYear() }}, Indiefy Inc
          </div>
        </div>
      <div class="text-center mt-1">
        <a href="/?lang=es" class="text-small mr-1 text-muted">Español</a>
        <a href="/?lang=en" class="text-small mr-1 text-muted">English</a>
        <a href="https://indiefy.net/free-music-distribution" class="text-small mr-1 text-muted" target="_blank">Free Music Distribution</a>
        <a href="https://indiefy.net/distribucion-digital-gratuita" class="text-small mr-1 text-muted" target="_blank">Distribución Digital Gratuita</a>
      </div>
    </div>
  </div>
  </footer>
</template>
<script>
export default {
  name: 'Footer',
  data: function () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue